
































































































































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import MathEquationInput from '@/math-equations/components/MathEquationInput.vue';

export default defineComponent({
  name: 'QueensLab1Part2Results',
  components: {
    MathEquationInput,
    CalculationInput,
    FileUploadUiComponent,
    StembleLatex,
    ChemicalNotationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        randomNumber: null,
        balancedEquation: null,
        rateConstantValue: null,
        rateConstantUncertainty: null,
        rateConstantUnits: null,
        rateLaw: null,
        litValue: null,
        litExplanation: null,
      },
      attachments: [] as File[],
    };
  },
});
